export default{
    state: {
        snackbar:{
            active: false,
            message: '',
            timeOut: 5000,
            action: ''
        }
    },
    getters: {
        snackbar: (state) => state.snackbar
    },
    mutations: {
        SnackbarSuccess: (state, value)=>{
            state.snackbar.active = value.success
            state.snackbar.message = value.message
            state.snackbar.action = value.action || 'success'
        },
    }
}